import { supabase } from '@/lib/supabaseClient';

const activityTypes = {
  LOGIN: { icon: 'LogIn', color: 'text-green-500' },
  ROUTE_SHARE: { icon: 'Share2', color: 'text-purple-500' },
  ROUTE_LOG_SUBMIT: { icon: 'ClipboardList', color: 'text-blue-500' },
  AVAILABILITY_UPDATE: { icon: 'CalendarCheck', color: 'text-yellow-500' },
};

export const logActivity = async (type, profile, details = {}) => {
  if (!profile || !profile.user_id) {
    console.warn('Activity log skipped: Missing profile or user_id.');
    return;
  }

  const activityConfig = activityTypes[type];
  if (!activityConfig) {
    console.warn(`Activity log skipped: Unknown type '${type}'.`);
    return;
  }

  let action_description = '';
  const actor_name = profile.display_name_for_payload || profile.full_name || profile.email || 'A user';

  switch (type) {
    case 'LOGIN':
      action_description = 'logged in.';
      break;
    case 'ROUTE_SHARE':
      action_description = `shared route '${details.routeName}' with ${details.recipientName}.`;
      break;
    case 'ROUTE_LOG_SUBMIT':
      action_description = `submitted a route log for ${details.date}.`;
      break;
    case 'AVAILABILITY_UPDATE':
      action_description = `updated availability for the week of ${details.weekCommencing}.`;
      break;
    default:
      action_description = 'performed an action.';
  }

  let ip_address = '---.---.---.---';
  try {
    const ipRes = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipRes.json();
    ip_address = ipData.ip;
  } catch (e) {
    console.warn('Could not fetch IP for logging:', e);
  }

  try {
    const { error } = await supabase.from('activity_logs').insert({
      user_id: profile.user_id,
      actor_name,
      action_description,
      ip_address,
      icon_name: activityConfig.icon,
      icon_color: activityConfig.color,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : 'Server',
      details: details,
    });

    if (error) {
      console.error('Error logging activity:', error);
    }
  } catch (e) {
    console.error('Exception during activity logging:', e);
  }
};